module.exports = __webpack_public_path__ + "img/symbol_6.72711849.png";